import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "widget-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InterventionRequest = _resolveComponent("InterventionRequest")!
  const _component_Preventive = _resolveComponent("Preventive")!
  const _component_PreventiveOut = _resolveComponent("PreventiveOut")!
  const _component_Estimate = _resolveComponent("Estimate")!
  const _component_Billing = _resolveComponent("Billing")!
  const _component_HomePageModale = _resolveComponent("HomePageModale")!
  const _component_EnqueteModalContent = _resolveComponent("EnqueteModalContent")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!

  return (!_ctx.isDashboardLoading && _ctx.traductionsLoaded)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listeWidgets, (widget) => {
          return (_openBlock(), _createElementBlock("span", {
            key: widget.id,
            class: "display-content"
          }, [
            (widget.typeWidgetId === _ctx.TYPE_WIDGET_DEMANDE_INTERVENTION_ID())
              ? (_openBlock(), _createBlock(_component_InterventionRequest, {
                  key: 0,
                  widget: widget,
                  class: "ombre"
                }, null, 8, ["widget"]))
              : _createCommentVNode("", true),
            (widget.typeWidgetId === _ctx.TYPE_WIDGET_PREVENTIVE_ID())
              ? (_openBlock(), _createBlock(_component_Preventive, {
                  key: 1,
                  widget: widget,
                  class: "ombre"
                }, null, 8, ["widget"]))
              : _createCommentVNode("", true),
            (widget.typeWidgetId === _ctx.TYPE_WIDGET_INTERVENTION_ID())
              ? (_openBlock(), _createBlock(_component_PreventiveOut, {
                  key: 2,
                  widget: widget,
                  class: "ombre"
                }, null, 8, ["widget"]))
              : _createCommentVNode("", true),
            (widget.typeWidgetId === _ctx.TYPE_WIDGET_DEVIS_ID())
              ? (_openBlock(), _createBlock(_component_Estimate, {
                  key: 3,
                  widget: widget,
                  class: "ombre"
                }, null, 8, ["widget"]))
              : _createCommentVNode("", true),
            (_ctx.hasRightFinancier && widget.typeWidgetId === _ctx.TYPE_WIDGET_FACTURE_ID())
              ? (_openBlock(), _createBlock(_component_Billing, {
                  key: 4,
                  widget: widget,
                  class: "ombre"
                }, null, 8, ["widget"]))
              : _createCommentVNode("", true)
          ]))
        }), 128)),
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "height-1px" }, null, -1)),
        (_ctx.showHomePageModal)
          ? (_openBlock(), _createBlock(_component_HomePageModale, { key: 0 }))
          : _createCommentVNode("", true),
        (_ctx.showEnqueteModal)
          ? (_openBlock(), _createBlock(_component_Modal, {
              key: 1,
              onCancel: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showEnqueteModal = false)),
              closeOnClickOutside: false
            }, {
              default: _withCtx(() => [
                _createVNode(_component_EnqueteModalContent, {
                  onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showEnqueteModal = false)),
                  onAnswer: _ctx.handleAnswer
                }, null, 8, ["onAnswer"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createBlock(_component_LoaderComponent, { key: 1 }))
}